// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { FieldsFactory } from "../Factory/FieldsFactory.js"
import { MessageProcessorBase } from "./MessageProcessorBase.ts"
import { DirectPropertyMessage } from "../../../../Utils/DirectMessages/DirectPropertyMessage.js"

export let PropertyMessageProcessor = function ()
{

}
PropertyMessageProcessor.prototype = Object.create(MessageProcessorBase.prototype)

PropertyMessageProcessor.prototype.decode = function (fs)
{
    let msg = new DirectPropertyMessage()
    let ff = FieldsFactory

    msg.Name = fs.GetValue(ff.FIELD_NAME)
    msg.Value = fs.GetValue(ff.FIELD_VALUE)

    msg.OwnerType = fs.GetValue(ff.FIELD_OWNER_TYPE)
    msg.OwnerID = fs.GetValue(ff.FIELD_ID)

    return [msg]
}